import React from 'react';
import classnames from 'classnames';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover, PopoverProps } from '../index';
import cn from './styles.module.scss';

export const InfoPopover = ({
  children,
  classNames,
  ...props
}: PopoverProps) => {

  return (
    <Popover
      trigger="click"
      placement="right"
      destroyOnHidden
      classNames={
        typeof classNames === 'function'
          ? classNames
          : {
              ...classNames,
              root: classnames(cn.root, classNames?.root),
            }
      }
      {...props}
    >
      {/* The <span> wrapper gives rc-trigger a measurable DOM node for
          positioning. Removing it breaks placement when InfoIcon is the
          child. */}
      <span>{children || <InfoCircleOutlined className={cn.icon}/>}</span>
    </Popover>
  );
};
